import { isPlatformBrowser, NgClass, NgForOf, NgIf } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { TlPagination } from 'src/app/interfaces/general-interfaces';
import { TimeAgoModule } from 'src/app/pipes/time-ago/time-ago.module';
import { ListsHelperService } from 'src/app/services/helpers/lists-helper.service';
import { DeleteModalText } from 'src/app/services/http-services/lists/lists-http-intterfaces';
import { ListsHttpService } from 'src/app/services/http-services/lists/lists-http.service';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { AuthenticationHelperService } from 'src/app/services/helpers/authentication-helper.service';
import { ItemsHttpService } from 'src/app/services/http-services/items/items-http.service';
import { ToastrService } from 'ngx-toastr';
import { StarsComponent } from '../stars/stars.component';
import { ShareEntitiesEnums } from 'src/app/enums/chat-enums';
import { SharingOptionsModalComponent } from 'src/app/pages/my-profile/components/sharing-options-modal/sharing-options-modal.component';
import { ReportModalComponent } from '../report-modal/report-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { Meta } from '@angular/platform-browser';
import {UserRoles} from '../../enums/general-enums';
import {CheckActiveRoleModule} from '../../pipes/check-active-role/check-active-role.module';

@Component({
  selector: 'app-reviews',
  standalone: true,
  imports: [
    NgForOf,
    RouterModule,
    NgIf,
    TimeAgoModule,
    ConfirmModalComponent,
    StarsComponent,
    SharingOptionsModalComponent,
    NgClass,
    ReportModalComponent,
    TranslateModule,
    CheckActiveRoleModule
  ],
  templateUrl: './reviews.component.html',
})
export class ReviewsComponent implements OnInit, OnChanges {
  @Input() reviewObj: any;
  @Input() isList = false;
  @Output() refreshSinglePage = new EventEmitter<boolean>();
  pageNum = 1;
  reviews: any[] = [];
  pagination!: TlPagination;
  PAGES_AND_PATHS = PAGES_AND_PATHS;
  isDropdownOpen = false;
  selectedReview: any;
  isDeleteModalOpen = false;
  modalText: DeleteModalText = { title: '', description: '', button: '' };
  loggedUser: any;
  isSharePostModalOpen = false;
  ShareEntitiesEnums = ShareEntitiesEnums;
  reviewUrl = '';
  isReportModalOpen = false;

  constructor(
    private listsHttpService: ListsHttpService,
    private router: Router,
    public listsHelperService: ListsHelperService,
    private authenticationHelperService: AuthenticationHelperService,
    private itemsHttpService: ItemsHttpService,
    private toastService: ToastrService,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loggedUser = this.authenticationHelperService.getUserData;
    }
    // if (this.reviewObj) {
    //   this.isList ? this.getListReviews() : this.getItemReviews();
    // }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.reviewObj.currentValue) {
      this.isList ? this.getListReviews() : this.getItemReviews();
    }
  }

  getListReviews(): void {
    this.listsHttpService.getListReviews(this.reviewObj.id, this.pageNum).then((res: { data: any[], pagination: TlPagination }) => {
      this.reviews = res.data;
      this.pagination = res.pagination;
    });
  }

  getItemReviews(): void {
    this.listsHttpService.getItemReviews(this.reviewObj.id, this.pageNum).then((res: { data: any[], pagination: TlPagination }) => {
      this.reviews = res.data;
      this.pagination = res.pagination;
    });
  }

  openCreateReviewPage(): void {
    const reviewDetails = {
      obj: this.reviewObj
    };
    this.router.navigate([PAGES_AND_PATHS.createReview.pagePath, this.isList ? 'list' : 'item'], { state: reviewDetails })
  }

  openViewMore(review: any, event: any): void {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
    this.selectedReview = review;
  }

  openEditReview(review: any): void {
    const reviewDetails = {
      obj: review
    };
    this.router.navigate([PAGES_AND_PATHS.updateReview.pagePath, this.isList ? 'list' : 'item'], { state: reviewDetails })
  }

  openDeleteModal(review: any): void {
    this.selectedReview = review;
    this.isDeleteModalOpen = true;
    this.modalText.title = 'Delete review?';
    this.modalText.description = 'Are you sure you wish to delete this review? This action cannot be undone.'
    this.modalText.button = 'GENERAL.delete';
  }

  takeAction(): void {
    this.isList ? this.deleteListReview() : this.deleteItemReview();
  }

  deleteItemReview(): void {
    this.isDeleteModalOpen = false;
    this.itemsHttpService.deleteItemReview(this.selectedReview.id).then((response: any) => {
      this.toastService.success(response.message);
      const index = this.reviews.findIndex(obj => obj.id === this.selectedReview.id);
      this.reviews.splice(index, 1);
      this.refreshSinglePage.emit(true);
    });
  }

  deleteListReview(): void {
    this.isDeleteModalOpen = false;
    this.itemsHttpService.deleteListReview(this.selectedReview.id).then((response: any) => {
      this.toastService.success(response.message);
      const index = this.reviews.findIndex(obj => obj.id === this.selectedReview.id);
      this.reviews.splice(index, 1);
      this.refreshSinglePage.emit(true);
    });
  }

  shareReview(review: any): void {
    this.selectedReview = review;
    this.isSharePostModalOpen = true;
    this.isList ? this.getPublicSingleListReview(this.selectedReview.id) : this.getPublicSingleItemReview(this.selectedReview.id);
  }

  getPublicSingleListReview(reviewId: number): void {
    this.itemsHttpService.getPublicReview(reviewId).then((response: any) => {
      const publicReview = response.data;
      if (isPlatformBrowser(this.platformId)) {
        this.reviewUrl = `${window.location.origin}/single-review/list/${publicReview.reviewable.id}/${reviewId}`;
      }
      this.meta.updateTag({
        property: 'og:title',
        content: `TheLysts review of ${publicReview.reviewable.title} by ${publicReview.author.username}`
      });
      this.meta.updateTag({
        property: 'og:description',
        content: `Rating: ${publicReview.rating} “${publicReview.review}”`
      });
      this.meta.updateTag({
        property: 'og:image',
        content: publicReview.reviewable.lyst_image_url !== null ? publicReview.reviewable.lyst_image_url : 'assets/images/og-image.png'
      });
      this.meta.updateTag({
        property: 'og:url', content: this.reviewUrl
      });
    });
  }

  getPublicSingleItemReview(reviewId: number): void {
    this.itemsHttpService.getPublicReview(reviewId).then((response: any) => {
      const publicReview = response.data;
      if (isPlatformBrowser(this.platformId)) {
        this.reviewUrl = `${window.location.origin}/single-review/item/${publicReview.reviewable.id}/${reviewId}`;
      }
      this.meta.updateTag({
        property: 'og:title',
        content: `TheLysts review of ${publicReview.reviewable.name} by ${publicReview.author.username}`
      });
      this.meta.updateTag({
        property: 'og:description',
        content: `Rating: ${publicReview.rating} “${publicReview.review}”`
      });
      this.meta.updateTag({
        property: 'og:image',
        content: publicReview.lyst_item_image_url !== null ? publicReview.lyst_item_image_url : 'assets/images/og-image.png'
      });
      this.meta.updateTag({
        property: 'og:url', content: this.reviewUrl
      });
    });
  }

  toggleLike(review: any): void {
    this.itemsHttpService.addReviewToFavorites(review.id).then((response: any) => {
      const index = this.reviews.findIndex(objRev => objRev.id === review.id);
      this.reviews[index] = response.data;
    });
  }

  protected readonly UserRoles = UserRoles;
}
